/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventModel } from './EventModel';
import {
    EventModelFromJSON,
    EventModelFromJSONTyped,
    EventModelToJSON,
} from './EventModel';

/**
 * 
 * @export
 * @interface DismissModel
 */
export interface DismissModel {
    /**
     * 
     * @type {string}
     * @memberof DismissModel
     */
    icon?: DismissModelIconEnum;
    /**
     * 
     * @type {EventModel}
     * @memberof DismissModel
     */
    event?: EventModel;
}


/**
 * @export
 */
export const DismissModelIconEnum = {
    Award: 'award',
    Close: 'close',
    Expert: 'expert',
    Pharmacy: 'pharmacy',
    Time: 'time',
    Truck: 'truck',
    Birthday: 'birthday',
    Box: 'box',
    ConnectWithAVetDesktop: 'connect-with-a-vet-desktop',
    ConnectWithAVetMobile: 'connect-with-a-vet-mobile',
    Gift: 'gift',
    HeartFill: 'heart-fill',
    HouseClinic: 'house-clinic',
    HouseShelter: 'house-shelter',
    Note: 'note',
    PrescriptionBottle: 'prescription-bottle',
    Storefront: 'storefront',
    Tag: 'tag'
} as const;
export type DismissModelIconEnum = typeof DismissModelIconEnum[keyof typeof DismissModelIconEnum];


/**
 * Check if a given object implements the DismissModel interface.
 */
export function instanceOfDismissModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DismissModelFromJSON(json: any): DismissModel {
    return DismissModelFromJSONTyped(json, false);
}

export function DismissModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DismissModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'event': !exists(json, 'event') ? undefined : EventModelFromJSON(json['event']),
    };
}

export function DismissModelToJSON(value?: DismissModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'icon': value.icon,
        'event': EventModelToJSON(value.event),
    };
}

